<ng-container *ngIf="productionScheduleItem.canBeRecolored(); else nonRecolorableItem">
  <svg:svg *ngIf="productionScheduleItem.isRecolored; else notRecolored" [attr.y]="drawingVerticalPosition" [attr.height]="drawingHeight">
    <defs>
      <svg:pattern [attr.id]="productionScheduleItem.uuid" x="0" y="0" width="100%" [attr.height]="drawingImageHeight" patternUnits="userSpaceOnUse">
        <svg:image x="0" y="0" width="100%" [attr.href]="productionScheduleItem.drawing.image.data" height="100%" preserveAspectRatio="none slice" />
      </svg:pattern>
    </defs>
    <svg:rect width="100%" x="0" height="100%" [attr.fill]="'url(#' + productionScheduleItem.uuid + ')'" />
  </svg:svg>

  <ng-template #notRecolored>
    <svg:g [attr.height]="drawingHeight">
      <svg:rect class="placeholder-for-recolored-drawing-background" width="100%" height="100%"></svg:rect>
      <svg:image
        class="placeholder-for-recolored-drawing"
        href="../assets/images/placeholder-recolored-drawing.svg"
        x="50%"
        y="50%"
        preserveAspectRatio="none slice"
        [attr.width]="getPlaceholderWidthAndHeight()"
        [attr.height]="getPlaceholderWidthAndHeight()"
        [attr.transform]="getPlaceholderPosition()"
      ></svg:image>
    </svg:g>
  </ng-template>

  <svg:rect y="0" class="production-schedule-item-cutbar cutbar-before" [attr.height]="cutbarBeforeHeight"></svg:rect>
  <svg:rect [attr.y]="cutbarAfterVerticalPosition" class="production-schedule-item-cutbar cutbar-after" [attr.height]="cutbarAfterHeight"></svg:rect>
</ng-container>

<ng-template #nonRecolorableItem>
  <svg:rect class="non-recolorable-item" width="100%" [attr.y]="drawingVerticalPosition" [attr.height]="drawingHeight"></svg:rect>
</ng-template>
